<template>
  <div>
    <a
      v-show="false"
      href="#"
      id="btnListTagihan"
      class="btn add-btn"
      data-toggle="modal"
      data-target="#listTagihan"
    >
      <i class="fa fa-plus"></i> List Tagihan
    </a>
    <!-- Add Client Modal -->
    <div id="listTagihan" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Info Tagihan</h5>
            <button
              id="btnCloseListTagihan"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="text-left">
              Tinggal selangkah lagi untuk layanan aktif.
              Anda memiliki
              <router-link
                :to="'/member/active-lisence?license_status=almost_expired'"
                class="badge badge-primary"
                data-dismiss="modal"
              >{{totalRecords}}</router-link>tagihan yang belum terbayar.
            </div>
            <br />
            <div class="text-center">
              <router-link
                :to="'/member/active-lisence?license_status=almost_expired'"
                class="btn btn-primary"
                data-dismiss="modal"
              >Lihat Tagihan</router-link>
              <!-- {{memberSessionArr.roles}} -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isLoading: false,
      totalRecords: 0,
      totalTagihan: 0
    };
    //  isactive : true
  },
  computed: {
    ...mapGetters(["fieldsGetLicenseList"]),
    memberSessionArr() {
      return this.$store.state.login.memberSession;
    }
  },
  async created() {
    if (
      typeof this.memberSessionArr.roles != "undefined" &&
      this.memberSessionArr.roles.length
    ) {
      this.memberSessionArr.roles.forEach(async (role, idx) => {
        if (role == "member") {
          this.fieldsGetLicenseList.license_status = await "almost_expired";
          await this.getLicenseList();
        }
      });
    }
  },
  methods: {
    // closeTagihan() {
    //   this.fieldsGetLicenseList.license_status = "almost_expired";
    //   return;
    // },
    async getLicenseList() {
      this.loading = await true;

      await this.$store
        .dispatch("license/getLicenseList", this.fieldsGetLicenseList)
        .then(response => {
          var { data } = response;
          this.totalRecords = data.totalRecords;
          if (this.totalRecords > 0) {
            setTimeout(function() {
              document.getElementById("btnListTagihan").click(); // Click on the checkbox
            }, 1000);
          }
        });
      this.loading = await false;
    }
  },

  mounted() {},
  name: "almostExpired"
};
</script>


// WEBPACK FOOTER //
// src/views/dashboard/components/AlmostExpired.vue